import { Button, Card, Divider } from 'antd';
import React, { useEffect } from 'react';
import administrativ from '../../images/common/administrativ.webp';
import financiar from '../../images/common/financiar.webp';
import projectManagement from '../../images/common/projectManagement.webp';
import serviceMentenanta from '../../images/common/serviceMentenanta.webp';
import '../Home/Home.css';

const Home: React.FC = () => {
  useEffect(() => {
    localStorage.setItem('selectedMenuKey', '');
  }, []);

  return (
    <>
      <div className='home-content'>
        <h1>Module disponibile</h1>
        <div className='module'>
          <Card title='Project management' className='card'>
            <img src={projectManagement} alt='projectManagement' style={{ width: '100%' }} />
            <Divider />
            <Button className='button'>Oferta</Button>
            <Button className='button'>Proiect + Subcontractanti</Button>
            <Button className='button'>Facturare</Button>
          </Card>

          <Card title='Service & Mentenanta' className='card'>
            <img src={serviceMentenanta} alt='serviceMentenanta' style={{ width: '100%' }} />
            <Divider />
            <Button className='button'>Oferta</Button>
            <Button className='button'>Dispecerat</Button>
            <Button className='button'>Rapoarte</Button>
            <Button className='button'>Facturare (Rapoarte)</Button>
          </Card>

          <Card title='Administrativ' className='card'>
            <img src={administrativ} alt='administrativ' style={{ width: '100%' }} />
            <Divider />
            <Button className='button'>Pontaj</Button>
            <Button className='button'>Gestiune</Button>
            <Button className='button'>Flota</Button>
            <Button className='button'>Utilaje</Button>
          </Card>

          <Card title='Financiar' className='card'>
            <img src={financiar} alt='financiar' style={{ width: '100%' }} />
            <Divider />
            <Button className='button'>E-factura</Button>
            <Button className='button'>Cashflow</Button>
            <Button className='button'>Bugetare</Button>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Home;
